export default __webpack_public_path__ + "static/media/CAL50250.682e8d28.jpg";